import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import EnumService from '../../services/Enum';

import Filters from '../../components/Filters/Filters';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';

import { removePagingAndSorting } from '../../helper/PaginationHelper';

export class ContextoFilter extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            filters: {
                name: '',
                type: '',
                grupoExibicao: '',
            },
            count: 0,
            optionsType: [],
            optionsGrupoExibicao: [],
        }
    }  

    // INPUTS
    handleChange = e => {
        this.setState({
            filters: {...this.state.filters, [e.target.name]: e.target.value }
        });
    };

    // APLICAR PERSISTENCIA
    handleFilterPersistence = (filters) => {
        filters = removePagingAndSorting(filters);

        this.setState({
            filters: {
                name: filters.find(f =>  f.field === 'variavel') ? filters.find(f =>  f.field === 'variavel').value : "",
                type: filters.find(f =>  f.field === 'tipo') ? filters.find(f =>  f.field === 'tipo').value : "",
                grupoExibicao: filters.find(f =>  f.field === 'agrupamento') ? filters.find(f =>  f.field === 'agrupamento').value : "",
            },
            count: filters.reduce((total, f) => f.value !== '' ? total + 1 : total, 0),
        })
    }

    // FILTROS
    handleFilterApply = () => {
        let f = [];
        const { filters } = this.state;

        if (filters.name) f.push({ field: 'variavel', value: filters.name });
        if (filters.type) f.push({ field: 'tipo', value: filters.type });
        if (filters.grupoExibicao) f.push({ field: 'agrupamento', value: filters.grupoExibicao });

        this.props.handleFilterChange(f);
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.setState({
            filters: {
                name: '',
                type: '',
                grupoExibicao: '',
            },
            count: 0,
        })
        this.props.handleFilterChange([], false);
    }

    // CONTAGEM DE FILTROS ATIVOS
    handleCountFilters = () => this.state.count;

    async componentDidMount() {     
        const tipos = await EnumService.listarTiposVariavel().then(res => res.data);
        const grupos = await EnumService.listarAgrupamentos().then(res => res.data);
        
        this.setState({
            optionsType: [...tipos],
            optionsGrupoExibicao: [...grupos], 
        });
    }

    render () {
        return (
            <Filters
                handleFilter={this.handleFilterApply}
                handleFilterClear={this.handleFilterClear}
                countFilters={this.handleCountFilters}
            >
                <Grid item container spacing={3}>
                    <Grid item sm={12} lg={3}>
                        <Text
                            label='Nome da Variável'
                            value={this.state.filters.name}
                            name='name'
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item sm={12} lg={3}>
                        <SelectOption
                            label="Tipo de Variável"
                            name='type'
                            value={this.state.filters.type}
                            onChange={this.handleChange}
                            options={this.state.optionsType}
                        />
                    </Grid>
                    <Grid item sm={12} lg={2}>
                        <SelectOption
                            label="Grupo de Exibição"
                            name='grupoExibicao'
                            value={this.state.filters.grupoExibicao}
                            onChange={this.handleChange}
                            options={this.state.optionsGrupoExibicao}
                        />
                    </Grid>
                </Grid>
            </Filters>
        )
    }
}

export default ContextoFilter;